import { render, staticRenderFns } from "./close-delivery-part.vue?vue&type=template&id=7df104ec"
import script from "./close-delivery-part.vue?vue&type=script&lang=js"
export * from "./close-delivery-part.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports